export interface ItemType {
  id: number;
  name: string;
  description: string | null;
  itemLevelId: number;
  color: string | null;
  icon: string | null;
  createdAt: string;
  updatedAt: string;
  createdBy: string;
  updatedBy: string;
}

export type ItemTypeMap = Record<number, ItemType>;

export interface ItemTypeUpsert {
  name: string;
  description: string | null;
  itemLevelId: number;
  color: string | null;
  icon: string | null;
}

export interface ItemTypeLevel {
  id: number;
  organizationId: string;
  level: number;
  name: string;
}

export const sortItemTypesByLevel = (
  itemTypes: ItemType[],
  itemTypeLevels: ItemTypeLevel[],
): ItemType[] => {
  const levelById = new Map(itemTypeLevels.map((l) => [l.id, l.level]));
  return [...itemTypes].sort((a, b) => {
    const la = levelById.get(a.itemLevelId) ?? Number.MAX_SAFE_INTEGER;
    const lb = levelById.get(b.itemLevelId) ?? Number.MAX_SAFE_INTEGER;
    if (la !== lb) return la - lb;
    return a.name.localeCompare(b.name);
  });
};
